<div class="container">
    <div class="denied">
        <h1>Acesso negado!</h1>
        <p>Não foi possível revalidar o e-mail utlizado</p>
        <p>
            Parece que o token utilizado para alterar a senha, já expirou! Clique no botão abaixo para gerar um
            novo token, e reinicie o processo para solictar nova senha!
        </p>
        <button (click)="refreshToken()">
            Recarregar <fa-icon [icon]="reloadIcon"></fa-icon>
        </button>
    </div>
</div>
